export default __webpack_public_path__ + "static/people-f7732fca27199521d1e34e3085319d75.jpg";